// extracted by mini-css-extract-plugin
export default {"__btn":"_button___btn__YaXJS","__redBtn":"_button___redBtn__JQjbd","__darkOrangeBtn":"_button___darkOrangeBtn__vXFJo"};